<template>
  <div class="placeholder">Block</div>
</template>
<script>
export default {
  name: 'Block'
}
</script>
<style scoped lang="less">
@import url('style/index.less');
</style>



// WEBPACK FOOTER //
// src/components/place-holder/place-holder.vue